import React from 'react';
import {Row, Icon, message, Col, Statistic, Card, Spin} from 'antd/lib/index';
import WebServerRestClient from "../../tools/WebServerRestClient";
import UserComponent from "../../components/UserComponent";
import CommonUtils from "../../tools/CommonUtils";
const echarts = require('echarts');

export default class DataStatistic extends UserComponent {

    constructor(props) {
        super(props);
        this.state = {
            dataStat: [],
            totalCount: 0,
            currentPage: 1,
            pageSize: 10,
            filteredInfo: null,
            sortedInfo: null,
        }
    }

    componentDidMount() {
        this.loadListData();
    }


    loadListData() {
        this.setState({loading: true});
        new WebServerRestClient().GET('/admin/data-statistic')
            .then(response => {
                CommonUtils.log("query data statistic response -> " + JSON.stringify(response));
                this.setState({loading: false});
                if (response.code === 200) {
                    this.setState({dataStat: response.data, loading: false})

                    const dateInvitedCount = response.data.dailyNewPaidUserCount;
                    let charts_xAxis = [], charts_series = [];
                    if (dateInvitedCount) {
                        for (let i = 0; i < dateInvitedCount.length; i++) {
                            charts_xAxis.push(dateInvitedCount[i].date);
                            charts_series.push(dateInvitedCount[i].value);
                        }
                    }
                    let charts_option = {
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: charts_xAxis
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [{
                            data: charts_series,
                            type: 'line',
                            smooth: true,
                            areaStyle: {}
                        }],
                        tooltip: {

                        },
                        itemStyle: {
                            color: '#5e77ff',
                            shadowColor: 'rgba(30, 30, 30, 0.25)'
                        }
                    };
                    let dailyNewPaidUserChart = echarts.init(document.getElementById('dailyNewPaidUserChart'));
                    dailyNewPaidUserChart.setOption(charts_option);
                } else if (response.code === 401 || response.code === 403) {
                    this.props.history.push('/login');
                } else {
                    message.error(response['msg']);
                }
            }).catch(err => {
            this.setState({loading: false});
            message.error("Error: " + err.message);
        });
    }

    handleChange = (pagination, filters, sorter) => {
        console.log('Various parameters', pagination, filters, sorter);
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    };


    render() {
        return (
            <div className="container">
            <Spin spinning={this.state.loading} delay={500}>
            <div style={{ background: '#ECECEC', padding: '30px' }}>
                <Row gutter={16}>

                    <Col span={4}>
                        <Card>
                            <Statistic title="Total Devices" value={this.state.dataStat.totalDeviceCount} prefix={<Icon type="appstore" />} />
                        </Card>
                    </Col>


                    <Col span={4}>
                        <Card>
                            <Statistic title="Android" value={this.state.dataStat.totalAndroidDeviceCount} prefix={<Icon type="android" />} />
                        </Card>
                    </Col>


                    <Col span={4}>
                        <Card>
                            <Statistic title="IOS" value={this.state.dataStat.totalIOSDeviceCount} prefix={<Icon type="apple" />} />
                        </Card>
                    </Col>

                    <Col span={4}>
                        <Card>
                            <Statistic title="Windows" value={this.state.dataStat.totalWindowsDeviceCount} prefix={<Icon type="windows" />} />
                        </Card>
                    </Col>
                    <Col span={4}>
                        <Card>
                            <Statistic title="Mac OS" value={this.state.dataStat.totalMacDeviceCount} prefix={<Icon type="apple" />} />
                        </Card>
                    </Col>

                </Row>

                <Row gutter={16}>
                    <Col span={4}>
                        <Card>
                            <Statistic title="Register Users" value={this.state.dataStat.totalRegisterUserCount} prefix={<Icon type="user" />} />
                        </Card>
                    </Col>
                    <Col span={4}>
                        <Card>
                            <Statistic title="Paid Users" value={this.state.dataStat.totalPaidUserCount} prefix={<Icon type="user" />} />
                        </Card>
                    </Col>
                    <Col span={4}>
                        <Card>
                            <Statistic title="Android Pay" value={this.state.dataStat.totalAndroidPaidUserCount} prefix={<Icon type="android" />} />
                        </Card>
                    </Col>
                    <Col span={4}>
                        <Card>
                            <Statistic title="IOS Pay" value={this.state.dataStat.totalIOSPaidUserCount} prefix={<Icon type="apple" />} />
                        </Card>
                    </Col>
                    <Col span={4}>
                        <Card>
                            <Statistic title="Web Pay" value={this.state.dataStat.totalWebPaidUserCount} prefix={<Icon type="ie" />} />
                        </Card>
                    </Col>
                </Row>


                <Row gutter={16}>

                    <Col span={4}>
                        <Card>
                            <Statistic title="Unexpired Users" value={this.state.dataStat.totalPaidUserAndNotExpireCount} prefix={<Icon type="user" />} />
                        </Card>
                    </Col>
                    <Col span={4}>
                        <Card>
                            <Statistic title="Unexpired & First" value={this.state.dataStat.totalFirstPaidNotExpiredUsersCount} prefix={<Icon type="user" />} />
                        </Card>
                    </Col>
                    <Col span={4}>
                        <Card>
                            <Statistic title="Repurchase" value={this.state.dataStat.totalPaidAgainUserCount} prefix={<Icon type="user" />} />
                        </Card>
                    </Col>
                    <Col span={4}>
                        <Card>
                            <Statistic title="Repurchase Rate" value={this.state.dataStat.repurchaseRate} prefix={<Icon type="pie-chart" />} />
                        </Card>
                    </Col>
                </Row>

            </div>

            <div style={{height: 303, backgroundColor: '#F0EFEB'}} id={'dailyNewPaidUserChart'}></div>
            </Spin>
            </div>
        )
    }

}
